import { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import { Main, Content } from "../../../components/Layout";
import { Col, Row, Table, Form } from "react-bootstrap";
import tableStyle from "../../../components/Table/Table.module.css";
import DatePicker from "../../../components/DatePicker";
import { InputTime } from "../../../components/Input";
import Slct from "../../../components/Slct";
import styleButton from "../../../components/Button/Button.module.css";
import IcLixo from "../../../components/Svg/IcLixo";
import { toast } from "react-toastify";
import Loading from "../../../components/Loading";
import Checkbox from "../../../components/Checkbox";
import api from "../../../services/api";
import useWrapper from "../../../hooks/useWrapper";
import Tooltip2 from "../../../components/Tooltip";

export default function AdminCalendar() {
  const { setbreadcrumb, config } = useWrapper();

  const [reload, setreload] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);

  const [calendar, setcalendar] = useState();
  const [categoriesRaw, setcategoriesRaw] = useState();
  const [allEvents, setallEvents] = useState();
  const [allResources, setallResources] = useState();
  useEffect(() => {
    api.get("templatecalendars", config).then(response => {
      const _calendar = response.data.map(__task => ({
        ...__task,
        ...(__task.is_contract
          ? {
              event_id: "contrato",
            }
          : __task.is_last_payment
          ? {
              event_id: "parcela",
            }
          : {}),
      }));
      setcalendar(_calendar);
    });
    api.get("categories?only_attendance=0", config).then(response => {
      setcategoriesRaw(response.data.data);
    });
  }, [reload]);

  useEffect(() => {
    if (categoriesRaw) {
      setallEvents(
        [
          {
            label: " Contratuais",
            category_id: null,
            resources: [],
            options: [
              { label: "Contrato", value: "contrato", category_id: null },
              { label: "Última Parcela", value: "parcela", category_id: null },
            ],
          },
        ].concat(
          categoriesRaw.map(e => ({
            label: e.name,
            category_id: e.id,
            resources: e.resource.map(e2 => ({
              label: e2.name,
              value: e2.id,
              category_id: e.id,
            })),
            options: e.event.map(e2 => ({
              label: e2.name,
              value: e2.id,
              category_id: e.id,
            })),
          })),
        ),
      );
      let _all_resources = [];
      categoriesRaw.forEach(e => {
        e.resource.forEach(e2 => {
          _all_resources.push({
            value: e2.id,
            label: e2.name,
            category_id: e.id,
          });
        });
      });
      setallResources(_all_resources);
      setLoadingPage(false);
    }
  }, [categoriesRaw]);

  const formatGroupLabel = data => (
    <div style={{ opacity: 0.5 }}>
      <span>{data.label}</span>
    </div>
  );

  const saveCalendar = () => {
    api
      .post(
        "templatecalendars",
        {
          template: calendar.map(__task => ({
            id: __task.id,
            title: __task.title,
            all_day: __task.all_day,
            date_end: __task.date_end,
            date_start: __task.date_start,
            ...(__task.event_id === "contrato"
              ? {
                  is_last_payment: false,
                  is_contract: true,
                  event_id: null,
                }
              : __task.event_id === "parcela"
              ? {
                  is_last_payment: true,
                  is_contract: false,
                  event_id: null,
                }
              : {
                  event_id: __task.event_id,
                }),
            category_id: __task.category_id,
            resource_id: __task.resource_id,
            count_days: Number(__task.count_days),
            for_trainees: __task.for_trainees,
            type_time: __task.type_time || "daily",
            uid: __task.uid || uuid(),
          })),
        },
        config,
      )
      .then(() => {
        toast.success("Calendário salvo com sucesso!");
        setreload(!reload);
      })
      .catch(err => {
        toast.error("Preecha todos os campos!");
      });
  };

  useEffect(() => {
    setbreadcrumb([{ label: "Administrativo" }]);
  }, []);

  return (
    <Main>
      {!loadingPage ? (
        <Content>
          <h2 className="mini-title">Calendário</h2>
          <p className="small-label font-italic mb-3">
            Todas as turmas cadastradas no sistema tem um calendário automático de tarefas na agenda. O Formou te
            oferece um fluxo padrão predefinido para o disparo dessas tarefas. Mas você pode personalizar os
            compromissos de acordo com o fluxo de trabalho da empresa. Lembrando que o calendário será aplicado apenas
            ara as novas turmas adicionadas ao sistema após sua configuração, não recalculando os calendários de turmas
            já previamente cadastradas.
          </p>
          <Table className={`mt-3 ${tableStyle.table}`}>
            <thead>
              <tr>
                <th style={{ minWidth: "200px" }}>Título</th>
                <th style={{ width: "90px" }}>Início</th>
                <th style={{ width: "90px" }}>Fim</th>
                <th style={{ minWidth: "150px" }}>Evento Base</th>
                <th style={{ minWidth: "150px" }}>Recurso</th>
                <th style={{ minWidth: "100px" }}>Tempo</th>
                <th style={{ minWidth: "100px", textAlign: "end" }}>Turma</th>
                <th style={{ minWidth: "50px", textAlign: "end" }}></th>
              </tr>
            </thead>
            <tbody>
              {calendar?.map((__task, __task_i) => (
                <tr>
                  <td>
                    <Tooltip2 tip={__task.title}>
                      <Form.Control
                        type="text"
                        onChange={__ev => {
                          let _calendar = [...calendar];
                          _calendar[__task_i].title = __ev.target.value;
                          setcalendar(_calendar);
                        }}
                        value={__task.title}
                      />
                    </Tooltip2>
                  </td>
                  <td>
                    <DatePicker
                      showTimeSelect
                      showTimeSelectOnly
                      timeFormat="HH:mm"
                      placeholder="00:00"
                      timeIntervals={15}
                      dateFormat="HH:mm"
                      selected={__task.date_start || null}
                      changeDate={__ev => {
                        let _calendar = [...calendar];
                        _calendar[__task_i].date_start = __ev;
                        setcalendar(_calendar);
                      }}
                    />
                  </td>
                  <td>
                    <DatePicker
                      showTimeSelect
                      showTimeSelectOnly
                      timeFormat="HH:mm"
                      placeholder="00:00"
                      timeIntervals={15}
                      dateFormat="HH:mm"
                      selected={__task.date_end || null}
                      changeDate={__ev => {
                        let _calendar = [...calendar];
                        _calendar[__task_i].date_end = __ev;
                        setcalendar(_calendar);
                      }}
                    />
                  </td>
                  <td>
                    <Slct
                      options={allEvents || []}
                      value={__task.event_id}
                      onChange={__ev => {
                        let _calendar = [...calendar];
                        _calendar[__task_i].event_id = __ev.value;
                        _calendar[__task_i].category_id = __ev.category_id;
                        setcalendar(_calendar);
                      }}
                      formatGroupLabel={formatGroupLabel}
                      className="w-100"
                      placeholder="..."
                    />
                  </td>
                  <td>
                    <Slct
                      options={
                        __task.category_id
                          ? allResources.filter(e2 => e2.category_id === __task.category_id)
                          : allEvents.map(__event => ({
                              label: __event.label,
                              category_id: __event.category_id,
                              options: __event.resources,
                            }))
                      }
                      value={__task.resource_id}
                      onChange={ev => {
                        let _calendar = [...calendar];
                        _calendar[__task_i].resource_id = ev.value;
                        setcalendar(_calendar);
                      }}
                      className="w-100"
                      placeholder="..."
                      formatGroupLabel={__task.category_id ? null : formatGroupLabel}
                    />
                  </td>
                  <td>
                    <InputTime
                      value={{
                        multiplier: __task.count_days_multi || 1,
                        value: __task.count_days,
                        frequency: __task.type_time || "daily",
                      }}
                      valueChange={ev => {
                        let _calendar = [...calendar];
                        _calendar[__task_i].count_days = ev;
                        setcalendar(_calendar);
                      }}
                      frequencyChange={ev => {
                        let _calendar = [...calendar];
                        _calendar[__task_i].type_time = ev;
                        setcalendar(_calendar);
                      }}
                    />
                  </td>
                  <td className="text-end">
                    <Checkbox
                      name="for_trainees"
                      checked={__task.for_trainees}
                      onChange={ev => {
                        let _calendar = [...calendar];
                        _calendar[__task_i].for_trainees = ev.target.checked;
                        setcalendar(_calendar);
                      }}
                    />
                  </td>
                  <td className="text-end">
                    <button
                      onClick={() => {
                        let _calendar = [...calendar];
                        _calendar.splice(__task_i, 1);
                        setcalendar(_calendar);
                      }}
                      type="button"
                      className="simple-ico"
                      alt="Apagar"
                    >
                      <IcLixo />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <button
            className={`${styleButton.button_add}`}
            type="button"
            colorScheme="primary"
            onClick={() => {
              setcalendar([
                ...calendar,
                {
                  id: null,
                  count_days: null,
                  date_start: null,
                  date_end: null,
                  event_id: null,
                  resource_id: null,
                  title: "",
                  for_trainees: true,
                },
              ]);
            }}
          >
            <span>Adicionar Tarefa</span>
          </button>
          <Row className="mt-4">
            <Col className="d-flex justify-content-end">
              <div>
                <button
                  type="button"
                  className={styleButton.button_primary}
                  onClick={() => {
                    saveCalendar();
                  }}
                >
                  Salvar
                </button>
              </div>
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
